import { Observable } from 'rxjs/Observable'
import * as actions from './actions'
import { api } from './api'
import { combineEpics } from 'redux-observable';
import { map, startWith, catchError } from 'rxjs/operators'


const searchListing = action$ => {
  return action$
    .ofType(actions.searchListing.toString())
    .debounceTime(1000)
    .switchMap(({payload}) => {
       return api
         .searchListing(payload)
         .pipe(
          map(actions.searchListingSuccess),
          startWith(actions.searchListingPending()),
          catchError(() => Observable.of(actions.searchListingFailed()))
         )
    })
}

export const epic = combineEpics(searchListing)